exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entity .el-carousel[data-v-35545f56]{text-align:center}.entity .el-carousel .mainImg[data-v-35545f56]{max-height:100%}.entity .el-carousel .mainInfo[data-v-35545f56]{position:absolute;bottom:0;width:100%;line-height:50px;color:#fff;font-weight:400;font-size:18px;background-color:rgba(0,0,0,.2)}", ""]);

// exports
